import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { FeatureEnum } from '@/graphql/generated';
import featureApi from '@/slices/features/feature.api';
import { isFeatureEnabled } from '@/slices/features/feature.selector';
import { RootState } from '@/store';

import {
  FileIcon,
  MaterialityIcon,
  MaturityIcon,
  PriorityUpIcon,
  RoadmapIcon,
} from '@/components/icons';
import { usePermissionChecker } from '@/hooks/usePermissionChecker';
import { useTranslation } from '@/hooks/useTranslation';
import { AppRoutes } from '@/screens/AppRoutes';

import { NavItem } from './NavItem';

export const useDeliverableNavItems = () => {
  const { isGranted } = usePermissionChecker();
  const { t } = useTranslation();
  const items: { key: string; element: ReactNode }[] = [];

  featureApi.endpoints.getEnabledFeatures.useQuery();
  const canAccessReportExportsPage = useSelector((state: RootState) =>
    isFeatureEnabled(state, 'can_access_report_exports_page'),
  );

  if (
    canAccessReportExportsPage &&
    isGranted(FeatureEnum.IndicatorsManagement)
  ) {
    items.push({
      key: 'report_exports',
      element: (
        <NavItem
          name={t('nav:page.report_exports')}
          Icon={FileIcon}
          href={AppRoutes.PublicationReportExports}
        />
      ),
    });
  }

  if (isGranted(FeatureEnum.DeliverableMaturityScore)) {
    items.push({
      key: 'maturity_evaluation',
      element: (
        <NavItem
          name={t('nav:page.maturity_score')}
          Icon={MaturityIcon}
          href={AppRoutes.PublicationMaturity}
        />
      ),
    });
  }
  if (isGranted(FeatureEnum.DeliverableMaterialityMatrix)) {
    items.push({
      key: 'materiality_matrix',
      element: (
        <NavItem
          name={t('nav:page.materiality_matrix')}
          Icon={MaterialityIcon}
          href={AppRoutes.PublicationMaterialityMatrix}
        />
      ),
    });
  }
  if (isGranted(FeatureEnum.DeliverableDoubleMaterialityMatrix)) {
    items.push({
      key: 'double_materiality_matrix',
      element: (
        <NavItem
          name={t('nav:page.double_materiality_matrix')}
          Icon={MaterialityIcon}
          href={AppRoutes.PublicationDoubleMaterialityMatrixIro}
        />
      ),
    });
  }
  if (isGranted(FeatureEnum.DeliverablePrioritizationMatrix)) {
    items.push({
      key: 'prioritization_matrix',
      element: (
        <NavItem
          name={t('nav:page.prioritization_matrix')}
          Icon={PriorityUpIcon}
          href={AppRoutes.PublicationPrioritizationMatrix}
        />
      ),
    });
  }
  if (isGranted(FeatureEnum.RoadmapManagement)) {
    items.push({
      key: 'roadmap',
      element: (
        <NavItem
          name={t('nav:page.roadmap')}
          Icon={RoadmapIcon}
          href={AppRoutes.Roadmap}
        />
      ),
    });
  }
  return items;
};
